<script>
    import "./exploreProjects.css";
    import ProjectCard from "../../components/project-card/ProjectCard.svelte";
    import { PROJECT_STATUSES, PROJECT_TAGS} from "../../constants/constants";
    import {projectType} from "../../store";
    import Dropdown from '../../components/dropdown/Dropdown.svelte';
    import Pagination from '../../components/pagination/Pagination.svelte';
    import { fetchProjects } from '../../../services/projectDetailService'

    export let params = {};

    const COUNT_PER_PAGE = 12;
    let totalCount = 0;
    let projects = [];
    let options = [
        'Featured',
        'Live',
        'Upcoming',
        'Completed',
    ];
    let pagesCount = 0;
    let currentPage = 1;

    projectType.set(params.id === "Live" ? PROJECT_STATUSES.LIVE : params.id);

    let selected = params.id === "Live" ? "Live" : params.id;

    const fetchProject = async () => {
        let projectStatus;
        switch(selected){
            case "Live":
                projectStatus = PROJECT_STATUSES.LIVE
                break;
            case PROJECT_STATUSES.UPCOMING:
                projectStatus = selected
                break;
            case PROJECT_STATUSES.COMPLETED:
                projectStatus = selected
                break;
            case PROJECT_TAGS.FEATURED:
                projectStatus = null
                break;
        }

        let projectResponse = await fetchProjects(projectStatus ,currentPage, COUNT_PER_PAGE );
        const {data , meta} = projectResponse;
        projects = data;
        totalCount = Number(meta.pagination.total);
        pagesCount = Math.ceil(totalCount / COUNT_PER_PAGE);
    }

    fetchProject();

    const replaceURL = (projectStatus) => {return history.replaceState({}, "", `#/explore-projects/${projectStatus}`)}

    const onStatusChange = async(value) => {
        currentPage = 1;
        selected = value;
        projectType.set(selected === "Live" ? PROJECT_STATUSES.LIVE : selected);
        switch(selected){
            case "Live":
                replaceURL("Live")
                break;
            case PROJECT_STATUSES.COMPLETED:
                replaceURL(PROJECT_STATUSES.COMPLETED)
                break;
            case PROJECT_STATUSES.UPCOMING:
                replaceURL(PROJECT_STATUSES.UPCOMING)
                break;
            case PROJECT_TAGS.FEATURED:
                replaceURL(PROJECT_TAGS.FEATURED)
                break;
        }
        await fetchProject();
    }

    projectType.subscribe(() => fetchProject());

    const onChangePage = (pageNumber) => {
        currentPage = pageNumber;
        fetchProject();
    }
    
</script>
<div class="view-all-wrapper container">
    <div class="flex items-center header-listing">
        <h2 class="header-title">{$projectType === PROJECT_STATUSES.LIVE ? "Live": selected} Sales</h2>
        <div class="ml-auto">
            <div class="flex column-direction">
            <label class="title">Project Status</label>
            <Dropdown
                options={options}
                value={selected}
                onValueChange={onStatusChange}
            />
            </div>
        </div>
    </div>
    <div class="preview-project-listing flex flex-wrap">
        {#if projects}
        {#each projects as project}
           <ProjectCard project={project}/>
        {/each}
        {/if}
    </div>
    {#if totalCount > COUNT_PER_PAGE}
        <Pagination current={currentPage} count={pagesCount} setCurrentPage={onChangePage} />
    {/if}
</div>
